export enum ExportQueryTypeEnum {
    ExportActiveRiders = 1,
    ExportCampaignRiders = 2,
}
